module.exports = __webpack_public_path__ + "img/img-area-varejo-banner.23f29768.png";